import { useEffect } from 'react';

const DEFAULT_TITLE = 'Seriously — Find your Person';
const DEFAULT_DESCRIPTION =
  'Seriously — discover your unconscious dating biases with Know Yourself, then find your person. Voice-first, no paywalls, no tricks.';

export function usePageMeta(title: string, description: string) {
  useEffect(() => {
    document.title = title;
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', description);
    return () => {
      document.title = DEFAULT_TITLE;
      document
        .querySelector('meta[name="description"]')
        ?.setAttribute('content', DEFAULT_DESCRIPTION);
    };
  }, [title, description]);
}
